import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { GetCustomerByCodeDTO, GetCustomerByCompanyNameResponseDTO } from "../../../pages/clienti/dto";
import { GetCustomersByCode, GetCustomersByCompanyName, resetGetCustomersByCodeStatus, resetGetCustomersByCompanyName, setExistingCode, setTakeover } from "../../../pages/clienti/slice";
import { setCDXClient } from "../../../pages/gestionePersonale/boxCDXM026/slice";
import { formatterDate } from "../../../utils";
import { InputProps, SearchType } from "./Input.types";

// Supponiamo che i dati siano forniti tramite un array

const Input: React.FC<InputProps> = ({ ...props }) => {
    const dispatch = useAppDispatch()
    const [showResults, setShowResults] = useState<boolean>(false); // Stato per la riga selezionata
    const [searchResults, setSearchResults] = useState<GetCustomerByCodeDTO[] | GetCustomerByCompanyNameResponseDTO[]>([]); // Stato per i risultati della ricerca
    const [responseResults, setResponseResults] = useState<GetCustomerByCodeDTO[] | GetCustomerByCompanyNameResponseDTO[]>([]); // Stato per i risultati della ricerca
    const [selectedResult, setSelectedResult] = useState<string | null>(null); // Stato per la riga selezionata
    const [selectedResultMessage, setSelectedResultMessage] = useState<string | null>(null); // messaggio per la riga selezionata
    const clientiState = useAppSelector(state => state.clienti)

    const handleSelectResult = (result: GetCustomerByCodeDTO | GetCustomerByCompanyNameResponseDTO) => {
        setSelectedResult(result.id);
        setSelectedResultMessage(result.clientCode + " - " + result.companyName)
        if (props.searchType === SearchType.COMPANY_NAME)
            dispatch(setCDXClient(result.id))
        else if (props.searchType === SearchType.TAKEOVER)
            dispatch(setTakeover(result.id))
        else
            dispatch(setExistingCode(result.clientCode))
        setSearchResults([]);
        if (props.onSelect) {
            props.onSelect(result.id);
        }
    };

    useEffect(() => {
        setSelectedResult(null);
        setShowResults(false)
        setSelectedResultMessage(null)
        setSelectedResult(null)
    }, [props.disabled])

    useEffect(() => {
        if (clientiState.getCustomersByCodeResponseStatus === 'successfully') {
            setSelectedResult(null);
            if (clientiState.getCustomersByCodeResponse !== undefined) {
                setResponseResults(clientiState.getCustomersByCodeResponse)
                setSearchResults(clientiState.getCustomersByCodeResponse)
                setShowResults(true)
            }
            dispatch(resetGetCustomersByCodeStatus('idle'))
        }
    }, [clientiState.getCustomersByCodeResponseStatus])

    useEffect(() => {
        if (clientiState.getCustomersByCompanyNameStatus === 'successfully' &&
            clientiState.getCustomersByCompanyNameResponse !== undefined
        ) {

            setSelectedResult(null);
            setResponseResults(clientiState.getCustomersByCompanyNameResponse)
            setSearchResults(clientiState.getCustomersByCompanyNameResponse)
            setShowResults(true)
            dispatch(resetGetCustomersByCompanyName())
        }
    }, [clientiState.getCustomersByCompanyNameStatus])



    return (
        <div className="flex w-full flex-col items-start gap-1">
            {props.label && <span className="text-label-md font-semibold text-brandPrimary-800">{props.label}</span>}
            <div
                className={clsx(
                    "flex h-[48px] max-h-[48px] w-full items-center justify-start gap-2 rounded-lg border px-3.5 py-0 box-shadow-xs",
                    {
                        "border-neutral-300 bg-white": !props.disabled && !props.error,
                        "border-neutral-300 bg-[rgba(242,242,250,1)]": props.disabled,
                        "border-red-600 bg-white": props.error && !props.disabled,
                    },
                )}
            >
                {props.startIcon && <div className="flex max-h-5 items-center">{props.startIcon}</div>}
                <input
                    placeholder={props.placeholder}
                    disabled={props.disabled}
                    value={props.value}
                    onClick={props.onClick}
                    maxLength={props.maxLength}
                    defaultValue={props.defaultValue}
                    onChange={(e) => {
                        if (e.target.value.length > 2) {
                            if (props.searchType === SearchType.COMPANY_NAME)
                                dispatch(GetCustomersByCompanyName(e.target.value))
                            else
                                dispatch(GetCustomersByCode(e.target.value))
                        }
                        else {
                            setShowResults(false)
                            setSelectedResultMessage(null)
                            setSelectedResult(null)
                        }

                        props.onChangeText && props.onChangeText(e.target.value);

                        if (responseResults.length > 0) {
                            const filteredResults = responseResults.filter((customer: GetCustomerByCodeDTO) =>
                                customer.clientCode.toLowerCase().includes(e.target.value.toLowerCase()) ||
                                customer.companyName.toLowerCase().includes(e.target.value.toLowerCase())
                            );
                            setSearchResults(filteredResults)
                        }


                    }}
                    className={clsx(
                        "h-5 w-full border-0 bg-transparent p-0 text-text-md font-medium text-neutral-700 outline-none ring-0 focus:ring-0 disabled:text-neutral-500",
                        "placeholder:text-text-md placeholder:font-medium placeholder:text-neutral-500",
                    )}
                />
                {props.endIcon && <div className="flex max-h-5 items-center">{props.endIcon}</div>}
            </div>
            {props.supportingText && (
                <span
                    className={clsx(
                        "text-sm font-semibold",
                        {
                            "text-red-500": props.error,
                            "text-neutral-400": !props.error,
                        },
                    )}
                >
                    {props.supportingText}
                </span>
            )}
            {(searchResults.length > 0 && showResults) && (
                <>
                    <ul className="search-results m-0 w-full list-none overflow-hidden rounded-lg border border-neutral-300 bg-white p-0 text-brandPrimary-800 shadow-sm">
                        {searchResults.map((customer) => (
                            <li
                                key={customer.id}
                                onClick={() => handleSelectResult(customer)}
                                className={clsx(
                                    "cursor-pointer px-2 py-2 text-sm hover:bg-neutral-100",
                                    {
                                        "bg-neutral-200": selectedResult === customer.id,
                                        "text-red-600": customer.endingDate !== null,
                                    },
                                )}
                            >
                                {customer.companyName} - {customer.countryRegion} - {customer.cuaa} - In {formatterDate(customer.startingDate)} Out {customer.endingDate ? formatterDate(customer.startingDate) : '-'}
                            </li>
                        ))}
                    </ul>
                    <div className="mt-3">
                        <span className="text-sm font-semibold text-brandPrimary-700">{selectedResultMessage}</span>
                    </div>
                </>
            )}
        </div>
    );
};

export default Input;
